export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    return { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) };
  }

  return null;

}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

export function rgbToHex(object) {
  const string = `rgb(${object.r},${object.g},${object.b})`;
  var rgb = string.match(/\d+/g);
  var r = parseInt(rgb[0]);
  var g = parseInt(rgb[1]);
  var b = parseInt(rgb[2]);
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function getColorString(color, opacity) {

  return `rgba(${color.r},${color.g},${color.b},${opacity})`;

}